import { message } from 'antd';
import { useCallback } from 'react';

export type CopyFn = (text: string, successMessage: string) => Promise<void>;

export const useCopyToClipboard = (): { copy: CopyFn } => {
  const copy = useCallback<CopyFn>(async (text, successMessage) => {
    try {
      await navigator.clipboard.writeText(text);
      void message.success(successMessage);
    } catch {
      void message.error('Failed to copy');
    }
  }, []);

  return { copy };
};
